import { Button, Group, Stack, Text } from "@mantine/core";
import React, { useState } from "react";
import { useLanguage } from "../../../../../stores/LanguageStore";
import { enrichDatafieldContent } from "../../../../../api/ContactAPI";
import { useParams } from "react-router-dom";
import { notifications } from "@mantine/notifications";
import GlobalLanguageSelector from "../../../../../components/Selectors/GlobalLanguageSelector";
import BackButton from "../../../../../components/View/BackButton";
import { IconWorldSearch } from "@tabler/icons-react";

const EnrichDatafieldLocal = ({ datafieldId, handleClose, onFinish }) => {
  const { contactListId } = useParams();
  const lang = useLanguage((s) => s.language);
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    let fd = new FormData(e.target);
    let data = Object.fromEntries(fd);

    setLoading(true);
    enrichDatafieldContent({
      contact_list_id: parseInt(contactListId),
      datafield_id: datafieldId,
      language: data.language,
    })
      .then((res) => {
        notifications.show({
          message: lang.contact_lists.datafield_content.success_enrich,
          color: "tertiary.8",
        });
        handleClose();
        onFinish?.()
      })
      .finally(() => setLoading(false));
  };

  return (
    <Stack
      component={"form"}
      onSubmit={handleSubmit}
      gap={"xs"}
      pos={"relative"}
    >
      <Text c={"dimmed"}>
        {lang.contact_lists.datafield_content.dialog.text_enrich}
      </Text>

      <GlobalLanguageSelector name={"language"} w="100%" size="sm" />

      <Group justify="end" mt={"md"}>
        <BackButton onClick={handleClose} />

        <Button
          leftSection={<IconWorldSearch size={18} />}
          loading={loading}
          color="primary"
          type="submit"
          size="md"
        >
          {lang.contact_lists.datafield_content.dialog.submit_button_enrich}
        </Button>
      </Group>
    </Stack>
  );
};

export default EnrichDatafieldLocal;
